import { render, staticRenderFns } from "./DrawerVacaciones.vue?vue&type=template&id=b460de8a&"
import script from "./DrawerVacaciones.vue?vue&type=script&lang=js&"
export * from "./DrawerVacaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports